import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

// HRS-3045: el SDK de Sentry (~275 KB raw con replay) iba en el bundle inicial aunque el
// DSN estaba a null. Ahora es un chunk propio que solo se descarga si el entorno define
// `sentryDsn`. Sin replayIntegration (128 KB) mientras no se decida usarlo; si hace
// falta, cargarlo con `Sentry.lazyLoadIntegration('replayIntegration')`.
const sentryDsn = environment.sentryDsn;
if (sentryDsn) {
  import('@sentry/angular')
    .then((Sentry) => {
      Sentry.init({
        dsn: sentryDsn,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 1,
        enableLogs: true,
        environment: environment.production ? 'production' : 'development',
        release: 'ciceroneweb@1.0.0',
      });
    })
    .catch(() => {
      /* sin observabilidad: la app sigue funcionando */
    });
}